import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Eyebrow, SectionLead, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <SectionShell tone="cream" data-id="element-78" data-mp="22krf1u5v5ect">
      <Eyebrow data-id="element-79" data-mp="22lsoju78dssf">Antes y después</Eyebrow>
      <SectionTitle data-id="element-80" data-mp="22iocybrfrurq">Deja de improvisar frente a una creatinina elevada</SectionTitle>
      <SectionLead data-id="element-81" data-mp="2zai95sa8szi3">
        Empieza a decidir como si tuvieras un nefrólogo sentado a tu lado en cada consulta.
      </SectionLead>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-82" data-mp="2qabx8au707l1">
        <div className="rounded-3xl border border-alert-500/25 bg-white p-5 sm:p-6" data-id="element-83" data-mp="2q8io8ow3xb9v">
          <p className="inline-flex items-center gap-2 rounded-full bg-alert-500/10 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-alert-600" data-id="element-84" data-mp="2lah8odxw3u35">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-85" data-mp="19vke6oixscoe" /> Antes
          </p>
          <h3 className="mt-3 font-display text-xl font-bold text-navy-900" data-id="element-86" data-mp="175m2z00398c3">
            Decides con incertidumbre
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-87" data-mp="1c3e5sp29uev2">
            {beforeItems.map(item => <li key={item} className="flex gap-2.5 text-[13.5px] leading-relaxed text-navy-700/85" data-id="element-88" data-mp="y57iu3yv1za6">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center" data-id="element-89" data-mp="132zjpnhhgvqi">
                  <XIcon className="h-4 w-4 text-alert-500" aria-hidden="true" data-id="element-90" data-mp="oecrwmao6bie" />
                </span>
                <span data-id="element-91" data-mp="t5uu1dofii4y">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border-2 border-renal-500/40 bg-white p-5 shadow-[0_10px_30px_rgba(14,35,64,0.07)] sm:p-6" data-id="element-92" data-mp="fepzur3tyi20">
          <p className="inline-flex items-center gap-2 rounded-full bg-renal-50 px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-renal-700" data-id="element-93" data-mp="jgl2q01et3hw">
            <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-94" data-mp="afmvl8vocfv3" /> Con la Ruta Renal™
          </p>
          <h3 className="mt-3 font-display text-xl font-bold text-navy-900" data-id="element-95" data-mp="2c4sqrze3phvc">
            Decides con una ruta clara
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-96" data-mp="27cr73selsova">
            {afterItems.map(item => <li key={item} className="flex gap-2.5 text-[13.5px] leading-relaxed text-navy-700/85" data-id="element-97" data-mp="23b5vsbhpwin7">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center" data-id="element-98" data-mp="1ydxfkgg4qool">
                  <CheckIcon className="h-4 w-4 text-renal-600" aria-hidden="true" data-id="element-99" data-mp="2v3eu7kx3bl2f" />
                </span>
                <span data-id="element-100" data-mp="2r2l72trh2aal">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-8 max-w-xl text-center font-display text-[19px] font-bold leading-snug text-navy-900 sm:text-2xl" data-id="element-101" data-mp="2m15iirq35lng">
        El resultado es simple: el paciente siente seguridad. Y tú también.
      </p>

      <div className="mt-8" data-id="element-102" data-mp="1aol7xl0gaooe">
        <CtaButton label="Quiero decidir con seguridad" sub="+300 páginas clínicas • 6 tomos premium • 5 bonos • 100% digital" data-id="element-103" data-mp="15o6ybyj7b6o9" />
      </div>
    </SectionShell>;
}